export class MapWidgetSearchParams {
  private _searchParams: URLSearchParams;

  constructor(searchParams: string) {
    this._searchParams = new URLSearchParams(searchParams);
  }

  getZoom(defaultValue: number): number {
    const paramValue = this._searchParams.get('zoom');

    return paramValue ? Number(paramValue) : defaultValue;
  }

  getCenter(defaultCenter: number[]): number[] {
    const param = this._searchParams.get('center');

    if (!param) return defaultCenter;

    const arr = decodeURIComponent(param).split(',');

    const [x, y] = arr.map(Number);

    if (x && y) return [x, y];

    return defaultCenter;
  }

  getLegend(defaultValue: boolean = true): boolean {
    const paramValue = this._searchParams.get('legend');

    if (paramValue === 'enable') return true;
    if (paramValue === 'disable') return false;

    return defaultValue;
  }

  hasNews(defaultValue: boolean = true): boolean {
    const paramValue = this._searchParams.get('news');

    if (paramValue === 'enable') return true;
    if (paramValue === 'disable') return false;

    return defaultValue;
  }

  hasEvents(defaultValue: boolean = true): boolean {
    const paramValue = this._searchParams.get('events');

    if (paramValue === 'enable') return true;
    if (paramValue === 'disable') return false;

    return defaultValue;
  }

  getCard(defaultValue: boolean = true): boolean {
    const paramValue = this._searchParams.get('card');

    if (paramValue === 'enable') return true;
    if (paramValue === 'disable') return false;

    return defaultValue;
  }

  getLayers(defaultValue: string[] = []): string[] {
    const layersStr = this._searchParams.get('layers');

    return layersStr ? layersStr.split(',') : defaultValue;
  }
}
